import { Text } from "@chakra-ui/react";
import React from "react";
import Font from "../Utils/Calligraphy";

interface SectionTitleProps {
  text: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ text }) => {
  return (
    <Text fontFamily={Font.Bold} fontSize={20} marginY={"1vh"}>
      {text}
    </Text>
  );
};
